<ng-container *ngFor="let feature of layerDescriptor.features">
    <div [innerHtml]="generateContent(feature)"></div><!-- TODO: Remove function call from template -->
</ng-container>